import {
  ComplianceHoldIcon,
  CreditHoldIcon,
  DisconnectedIcon,
  EmptyAlertIcon,
  SalesVarianceIcon,
  NoFitIcon,
  PotentialNoFitIcon,
  PotentialRunoutIcon,
  RunoutIcon,
  RunoutWithinIcon,
  StaleIcon,
} from './icons'

import type { FlagIconProps } from './icons'

export const TankAlertType = {
  StaleTankReading: 'stale tank reading',
  ComplianceHold: 'compliance hold',
  CreditHold: 'credit hold',
  DisconnectedNeedingManual: 'disconnected needing manual',
  TankMonitorDisconnected: 'tank monitor disconnected',
  RunoutWithinWarning: 'runout within warning',
  RunoutWithinError: 'runout within error',
  Empty: 'empty',
  SalesVariance: "today's sales variance",
} as const

export const WindowAlertType = {
  Runout: 'runout',
  PotentialRunout: 'potential runout',
  NoFit: 'no fit',
  PotentialNoFit: 'potential no fit',
  Empty: 'empty',
} as const

type TankAlertTypeValues = (typeof TankAlertType)[keyof typeof TankAlertType]
type WindowAlertTypeValues = (typeof WindowAlertType)[keyof typeof WindowAlertType]

type AnalyticIconProps = {
  title: TankAlertTypeValues | WindowAlertTypeValues
  size?: FlagIconProps['size']
  threshold?: number
}

export function AnalyticIcon({ title, size, threshold }: AnalyticIconProps) {
  const titleIgnoreCase = title.toLowerCase()

  switch (titleIgnoreCase) {
    case TankAlertType.RunoutWithinError:
      return <RunoutWithinIcon size={size} threshold={threshold} severity='error' />
    case TankAlertType.RunoutWithinWarning:
      return <RunoutWithinIcon size={size} threshold={threshold} severity='warning' />
    case WindowAlertType.Runout:
      return <RunoutIcon size={size} />
    case WindowAlertType.PotentialRunout:
      return <PotentialRunoutIcon size={size} threshold={threshold} />
    case WindowAlertType.PotentialNoFit:
      return <PotentialNoFitIcon size={size} threshold={threshold} />
    case WindowAlertType.NoFit:
      return <NoFitIcon size={size} />
    case TankAlertType.StaleTankReading:
      return <StaleIcon size={size} />
    case TankAlertType.ComplianceHold:
      return <ComplianceHoldIcon size={size} />
    case TankAlertType.CreditHold:
      return <CreditHoldIcon size={size} />
    case TankAlertType.DisconnectedNeedingManual:
    case TankAlertType.TankMonitorDisconnected:
      return <DisconnectedIcon size={size} />
    case TankAlertType.Empty:
      return <EmptyAlertIcon size={size} />
    case TankAlertType.SalesVariance:
      return <SalesVarianceIcon size={size} />
    default:
      return null
  }
}
